var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnterInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9922 9.94341C5.22465 10.1737 5.5983 10.1737 5.82858 9.94341L8.75482 7.00848C8.97858 6.78472 8.9851 6.42627 8.7722 6.19165L5.88941 3.29799C5.65913 3.06554 5.28547 3.06554 5.05303 3.29799C4.82058 3.52827 4.82058 3.90192 5.05303 4.13437L7.50351 6.62179L4.99003 9.1092C4.75975 9.33514 4.75758 9.70662 4.98351 9.93689C4.98568 9.93907 4.98785 9.94124 4.99003 9.94341H4.9922Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.61744C0 3.09378 2.85673 0.237053 6.38256 0.237053C9.90839 0.237053 12.7651 3.09378 12.7651 6.61961C12.7651 10.1454 9.90622 13 6.38256 13C2.85673 13 0 10.1433 0 6.61961V6.61744ZM0.981932 6.61744C0.981932 9.598 3.39549 12.0159 6.37822 12.0181C7.81201 12.0181 9.18715 11.4489 10.1995 10.4344C12.3067 8.32713 12.3067 4.90992 10.1995 2.8005C8.09225 0.691088 4.67504 0.69326 2.56562 2.8005C1.54893 3.81068 0.977587 5.18365 0.981932 6.61744Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterInput);
export default __webpack_public_path__ + "static/media/enter-input.71527adb87ce2f93231f41a3b7b7b579.svg";
export { ForwardRef as ReactComponent };